export default {"src":"/_next/static/media/empyOrders.0d225894.svg","height":202,"width":225,"blurWidth":0,"blurHeight":0};